/**
 * Permission checks for UI gating. The backend is the source of truth —
 * every user payload carries its `permissions` array (computed server-side
 * from backend/app/core/permissions.py), so no role table is duplicated here.
 *
 * Fail closed: no user profile → no permissions. Legacy shared-password
 * sessions are handled explicitly in AuthContext (keyed off the token),
 * never inferred from a missing profile.
 */
export const can = (user, permission) => {
  const perms = user?.permissions || [];
  return perms.includes('*') || perms.includes(permission);
};

export const isSuperAdmin = (user) => user?.role === 'super_admin';
